<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11.664" viewBox="0 0 14 11.664" class="scaling-svg">
      <path
        d="M3.2,11.664a.562.562,0,0,1-.575-.547V5.545H.575A.562.562,0,0,1,0,5V.547A.562.562,0,0,1,.575,0h12.85A.562.562,0,0,1,14,.547V5a.562.562,0,0,1-.575.547H11.371v5.571a.562.562,0,0,1-.575.547Zm.575-8.891v7.8h6.443v-7.8a.576.576,0,0,1,1.15,0V4.45H12.85V1.095H1.15V4.45H2.629V2.773a.576.576,0,0,1,1.15,0ZM6.425,8.613V8.246a1.952,1.952,0,0,1-1.46-1.858.576.576,0,0,1,1.15,0,.893.893,0,0,0,1.508.6.757.757,0,0,0-.276-1.261L6.213,5.28a1.833,1.833,0,0,1-.843-2.833.594.594,0,0,1,.8-.113.53.53,0,0,1,.119.766.762.762,0,0,0,.36,1.169l1.133.447a1.83,1.83,0,0,1,.7,2.994,2.026,2.026,0,0,1-.914.537v.367a.576.576,0,0,1-1.15,0Zm1.46-5.006A.811.811,0,0,0,7.709,3.1a.53.53,0,0,1,.114-.766.593.593,0,0,1,.8.108,1.864,1.864,0,0,1,.407,1.164.576.576,0,0,1-1.15,0Z"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class BankTransfersIcon extends Vue {}
</script>

<style>
</style>
